import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { STARFISH_DEVICE_DETAILS } from './url-constants';

type StarfishGatewayDeviceUpdateEndpointSpecification = ApiEndpointSpecification;
export const StarfishGatewayDeviceUpdateEndpointSpecification: StarfishGatewayDeviceUpdateEndpointSpecification = {
    url: STARFISH_DEVICE_DETAILS,
    method: HttpMethod.PUT,
    requestParamsSchemaName: 'StarfishGatewayDeviceUpdateRequestParams',
    requestBodySchemaName: 'StarfishGatewayDeviceUpdateRequestBody',
    okResponseSchemaName: 'StarfishGatewayDeviceUpdateOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:3
};

export const invokeStarfishGatewayDeviceUpdate = Helpers.makeApiRequestFn<
    Types.StarfishGatewayDeviceUpdateRequestParams,
    Types.StarfishGatewayDeviceUpdateRequestBody,
    Types.StarfishGatewayDeviceUpdateOkResponse
>(StarfishGatewayDeviceUpdateEndpointSpecification);
